import React, { useEffect, useRef } from "react";
import Button from "../../../Common/Buttons/Button";
import DatePicker from "../../../Common/Input/Datepicker";

interface RequiredInformationProps {
  dateOfBirth: string;
  setDateOfBirth: (date: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  cancelIcon: string;
  onDatePickerHeightChange?: (height: number) => void;
}

const RequiredInformation: React.FC<RequiredInformationProps> = ({
  dateOfBirth,
  setDateOfBirth,
  onCancel,
  onSubmit,
  isSubmitting,
  cancelIcon,
  onDatePickerHeightChange,
}) => {
  const datePickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const popper = document.querySelector(
        ".react-datepicker"
      ) as HTMLElement | null;
      if (popper) {
        const height = popper.offsetHeight;

        onDatePickerHeightChange?.(height);
      } else {
        onDatePickerHeightChange?.(0);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [onDatePickerHeightChange]);
  return (
    <div className="p-[18px]">
      <div className="flex justify-between py-[8px]">
        <h3 className="mb-6 font-semibold font-outfit">
          Information required!
        </h3>
        <img
          src={cancelIcon}
          onClick={onCancel}
          className="cursor-pointer w-[18px] h-[18px]"
          alt="Close"
        />
      </div>

      <p className="leading-[127%] text-[16px] font-outfit">
        Please note that to qualify for the Sootchy Education Program, you must
        be over 18 years.
      </p>

      <div ref={datePickerRef}>
        <DatePicker
          name="birthdate"
          label="Birth date"
          // Ensure the component re-renders when the date changes
          value={dateOfBirth}
          onChange={(value) => setDateOfBirth(value)}
          dateRestriction="past"
          requireAdult={true}
        />
      </div>

      <div className="mt-[20px] flex space-x-[24px]">
        <Button
          ariaLabel="previous"
          variant="secondary"
          label="Cancel"
          iconVisibility="hide"
          handleClick={onCancel}
        />
        <Button
          iconVisibility="hide"
          ariaLabel="next"
          label="Submit"
          loading={isSubmitting}
          handleClick={onSubmit}
        />
      </div>
    </div>
  );
};

export default RequiredInformation;
